import type {
  ActivationTaskCompletedProperties,
  OwnerActivationAnalytics,
} from './ownerActivationAnalyticsTypes';

/**
 * Emit `activation_task_completed` only when a task transitions from
 * incomplete to complete. Duplicate deliveries of the same domain event
 * (focus cycles, retries, bootstrap replays) must not emit duplicate
 * first-completion analytics.
 */
export function trackTaskCompletionOnce(
  analytics: OwnerActivationAnalytics,
  before: { completedAt: string | null },
  after: { completedAt: string | null },
  properties: ActivationTaskCompletedProperties,
): void {
  const wasComplete = before.completedAt !== null;
  const isComplete = after.completedAt !== null;
  if (wasComplete || !isComplete) return;
  analytics.track('activation_task_completed', properties);
}
